import { render, staticRenderFns } from "./NarrativeRenderTest.vue?vue&type=template&id=205528bc&"
import script from "./NarrativeRenderTest.vue?vue&type=script&lang=js&"
export * from "./NarrativeRenderTest.vue?vue&type=script&lang=js&"
import style0 from "./NarrativeRenderTest.vue?vue&type=style&index=0&id=205528bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports